var _style, _rect, _rect2, _rect3, _rect4, _g, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3F62AD;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{opacity:0.85;fill:#2EA9E1;}\r\n\t.st3{fill:#0097BD;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95.68,
    y: -130.14,
    className: "st0",
    width: 100.18,
    height: 100.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137.79,
    y: -105.92,
    className: "st1",
    width: 11.89,
    height: 55.02
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 139.2,
    y: -99.7,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 60.7876 -229.4996)",
    className: "st1",
    width: 11.89,
    height: 30.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.39,
    y: -116.31,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 45.2213 -261.451)",
    className: "st1",
    width: 11.89,
    height: 16.39
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st2",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.78,
    y: 68.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.79,
    y: 68.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.79,
    y: 74.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.79,
    y: 74.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 74.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.81,
    y: 74.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.79,
    y: 68.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 68.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.81,
    y: 68.35,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 62.34,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.81,
    y: 62.34,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 56.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.81,
    y: 56.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.81,
    y: 67.74,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 67.74,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.79,
    y: 56.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.79,
    y: 50.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.79,
    y: 50.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.79,
    y: 44.32,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.79,
    y: 38.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.78,
    y: 38.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.78,
    y: 32.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.78,
    y: 26.3,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.79,
    y: 26.3,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.79,
    y: 32.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 38.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.79,
    y: 38.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.79,
    y: 32.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 32.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.81,
    y: 38.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.81,
    y: 38.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.79,
    y: 44.32,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 50.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.81,
    y: 50.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 44.32,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.81,
    y: 44.32,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.81,
    y: 62.34,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.81,
    y: 56.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.81,
    y: 50.33,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.81,
    y: 44.32,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 38.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 61.73,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 55.73,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 49.72,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 43.71,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 38.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 32.31,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.82,
    y: 26.3,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 62.59,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 56.58,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 50.58,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 44.57,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 37.82,
    className: "st1",
    width: 6.01,
    height: 7.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 31.82,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 26.3,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 20.29,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.83,
    y: 20.29,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.84,
    y: 20.29,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.83,
    y: 56.71,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.83,
    y: 50.7,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.83,
    y: 44.7,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.83,
    y: 37.95,
    className: "st1",
    width: 6.01,
    height: 7.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.83,
    y: 31.94,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.83,
    y: 25.01,
    className: "st1",
    width: 6.01,
    height: 7.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.84,
    y: 51.79,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.84,
    y: 45.78,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.84,
    y: 39.03,
    className: "st1",
    width: 6.01,
    height: 7.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.84,
    y: 33.03,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.84,
    y: 26.1,
    className: "st1",
    width: 6.01,
    height: 7.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.61,
    y: 26.66,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.61,
    y: 38.67,
    className: "st1",
    width: 6.01,
    height: 7.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.61,
    y: 32.67,
    className: "st1",
    width: 6.01,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.62,
    y: 26.8,
    className: "st1",
    width: 6.01,
    height: 6.01
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: -130.05,
    className: "st3",
    width: 100,
    height: 100
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 227.75,
    y: -91.62,
    className: "st1",
    width: 10.96,
    height: 42.31
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 247.83,
    y: -91.62,
    className: "st1",
    width: 10.96,
    height: 42.31
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: -91.62,
    className: "st1",
    width: 10.96,
    height: 42.31
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 227.75,
    y: -110.36,
    className: "st1",
    width: 10.96,
    height: 10.96
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 258.79,
    y: -91.62,
    className: "st1",
    width: 21.23,
    height: 10.91
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 275.07,
    y: -93.09,
    className: "st3",
    width: 12.66,
    height: 12.66
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.da4aa1012721bdc4939784012447d032.svg";
export { ForwardRef as ReactComponent };